module.exports = function (breakpointsService, shopLocatorService, StorePickerService, settingsService, $window) {
	return {
		restrict: 'E',
		scope: {},
		link(scope) {
			scope.breakpointsService = breakpointsService;
			scope.isOpeningHoursActive = false;
			scope.storePicker = StorePickerService;
			scope.selectedStoreInfo = null;
			scope.storePagesRedirectSettings = null;
			scope.enableRedirect = false;

			settingsService.getFrontendSetting('StorePages', 'StorePagesRedirect')
				.then((res) => {
				scope.storePagesRedirectSettings = JSON.parse(res[0].Value);
				scope.enableRedirect = scope.storePagesRedirectSettings && scope.storePagesRedirectSettings.EnableRedirect;
            });

			scope.getStoreInfoUrlParams = function () {
					if (scope.selectedStoreInfo) {
						return shopLocatorService.generateUrlParamsForStoreInfos(scope.selectedStoreInfo);
					}
			};

			scope.toggleOpeningHours = function () {
				scope.isOpeningHoursActive = !scope.isOpeningHoursActive;
			};

			scope.redirectStorePage = function () {
				if (scope.storePagesRedirectSettings && scope.storePagesRedirectSettings.EnableRedirect) {
					const suburbYextFormat = scope.selectedStoreInfo.Suburb.trim().replace(/\s+/g, '-');
					let storePathUrl = `${scope.storePagesRedirectSettings.RedirectBaseUrl}/${scope.selectedStoreInfo.State}-${suburbYextFormat}-${scope.selectedStoreInfo.StoreNo}`;
					storePathUrl = storePathUrl.toLocaleLowerCase();
					$window.location.assign(storePathUrl);
				}
			};

			scope.$watch('storePicker.store.FulfilmentStoreID', function (storeId) {
				if (storeId) {
					shopLocatorService.getStore(storeId)
					.then(function (response) {
						scope.selectedStoreInfo = {
								Latitude: response.Latitude,
								Longitude: response.Longitude,
								State: response.State,
								StoreNo: response.StoreNo,
								Suburb: response.Suburb
						};
					});
				}
			});
		},
		template: require('./store-summary-panel.html').trim()
	};
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/shoplocator/store-summary-panel-directive.js
 **/